"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseQuery_1 = require("../../../BaseQuery");

var ExternalApiQueryMpiPortfolio =
/** @class */
function (_super) {
  __extends(ExternalApiQueryMpiPortfolio, _super);

  function ExternalApiQueryMpiPortfolio() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ExternalApiQueryMpiPortfolio.prototype.getOptions = function () {
    var _a = this.queryOptions.options,
        options = _a === void 0 ? {} : _a;
    return options.externalApi && options.externalApi.options && options.externalApi.options.mpi && options.externalApi.options.mpi.portfolio;
  };

  Object.defineProperty(ExternalApiQueryMpiPortfolio.prototype, "portfolioResponse", {
    get: function get() {
      var externalApiOptions = this.queryOptions.options && this.queryOptions.options.externalApi;
      var externalApiResponse = this.getExternalApiResponse(externalApiOptions, this.executionOptions);
      return externalApiResponse && externalApiResponse.MPI && externalApiResponse.MPI.portfolio;
    },
    enumerable: true,
    configurable: true
  });

  ExternalApiQueryMpiPortfolio.prototype.getRawValue = function (executionOptions) {
    this.executionOptions = executionOptions;
    var portfolioResponse = this.portfolioResponse;
    var options = this.options;

    if (options && portfolioResponse) {
      var type = options.type;

      if (type === 'chartData') {
        return this.getChartData(portfolioResponse, options);
      }

      if (type === 'period') {
        return this.getPeriod(portfolioResponse, options);
      }
    }

    return undefined;
  };

  ExternalApiQueryMpiPortfolio.prototype.getPeriod = function (portfolioResponse, options) {
    var periodOptions = options.options && options.options.period || {};

    if (portfolioResponse && portfolioResponse.portfolios && portfolioResponse.portfolios.length > 0 && periodOptions) {
      var code_1 = options.code;

      for (var _i = 0, _a = portfolioResponse.portfolios; _i < _a.length; _i++) {
        var portfolio = _a[_i];

        if (portfolio.statistics) {
          var statisticForCode = portfolio.statistics.find(function (s) {
            return s.code === code_1;
          });

          if (statisticForCode && statisticForCode.period) {
            return statisticForCode.period;
          }
        }
      }
    }

    return undefined;
  };

  ExternalApiQueryMpiPortfolio.prototype.getChartData = function (portfolioResponse, options) {
    var chartDataOptions = options.options && options.options.chartData || {};

    if (portfolioResponse && portfolioResponse.portfolios && portfolioResponse.portfolios.length > 0 && chartDataOptions) {
      var code_2 = options.code;

      if (!code_2) {
        return undefined;
      }

      var _a = chartDataOptions.groupBy,
          groupBy = _a === void 0 ? 'label' : _a;

      if (groupBy === 'label') {
        var rowByLabel = {};

        for (var portfolioIndex = 0; portfolioIndex < portfolioResponse.portfolios.length; portfolioIndex++) {
          var portfolio = portfolioResponse.portfolios[portfolioIndex];
          var portfolioKey = "portfolio_" + portfolio.portfolioId;

          if (portfolio.statistics) {
            var statisticForCode = portfolio.statistics.find(function (s) {
              return s.code === code_2;
            });

            if (statisticForCode && statisticForCode.values && statisticForCode.values.length > 0) {
              for (var _i = 0, _b = statisticForCode.values; _i < _b.length; _i++) {
                var statisticValue = _b[_i];
                var label = statisticValue.label,
                    value = statisticValue.value;

                if (!rowByLabel[label]) {
                  rowByLabel[label] = {
                    name: label
                  };
                }

                rowByLabel[label][portfolioKey] = value;

                if (portfolioIndex === 0 && statisticForCode.period) {
                  rowByLabel[label].periodStart = statisticForCode.period.start;
                  rowByLabel[label].periodEnd = statisticForCode.period.end;
                }
              }
            }
          }
        }

        return Object.values(rowByLabel);
      }

      if (groupBy === 'portfolio') {
        var rowByPortfolioKey = {};

        for (var portfolioIndex = 0; portfolioIndex < portfolioResponse.portfolios.length; portfolioIndex++) {
          var portfolio = portfolioResponse.portfolios[portfolioIndex];
          var portfolioKey = "portfolio_" + portfolio.portfolioId;

          if (portfolio.statistics) {
            var statisticForCode = portfolio.statistics.find(function (s) {
              return s.code === code_2;
            });

            if (statisticForCode && statisticForCode.values && statisticForCode.values.length > 0) {
              for (var _c = 0, _d = statisticForCode.values; _c < _d.length; _c++) {
                var statisticValue = _d[_c];
                var label = statisticValue.label,
                    value = statisticValue.value;

                if (!rowByPortfolioKey[portfolioKey]) {
                  rowByPortfolioKey[portfolioKey] = {
                    name: portfolioKey
                  };
                }

                rowByPortfolioKey[portfolioKey][label] = value;
              }

              if (statisticForCode.period) {
                rowByPortfolioKey[portfolioKey].periodStart = statisticForCode.period.start;
                rowByPortfolioKey[portfolioKey].periodEnd = statisticForCode.period.end;
              }
            }
          }
        }

        return Object.values(rowByPortfolioKey);
      }
    }

    return undefined;
  };

  return ExternalApiQueryMpiPortfolio;
}(BaseQuery_1.BaseQuery);

exports.ExternalApiQueryMpiPortfolio = ExternalApiQueryMpiPortfolio;